var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.9,
    height: 16.896,
    viewBox: "0 0 16.9 16.896",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add_6_",
    "data-name": "add (6)",
    transform: "translate(0 -0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_70",
    "data-name": "Union 70",
    d: "M14852.1-10713.06a8.457,8.457,0,0,1,8.448-8.448,8.46,8.46,0,0,1,8.452,8.448,8.46,8.46,0,0,1-8.452,8.448A8.457,8.457,0,0,1,14852.1-10713.06Zm1.31,0a7.149,7.149,0,0,0,7.139,7.142,7.15,7.15,0,0,0,7.143-7.142,7.152,7.152,0,0,0-7.143-7.143A7.149,7.149,0,0,0,14853.409-10713.06Zm6.485,3.213v-2.616h-2.619a.655.655,0,0,1-.653-.656.651.651,0,0,1,.653-.653h2.619v-2.62a.651.651,0,0,1,.653-.652.655.655,0,0,1,.657.652v2.62h2.615a.655.655,0,0,1,.657.653.658.658,0,0,1-.657.656h-2.615v2.616a.658.658,0,0,1-.657.656A.655.655,0,0,1,14859.895-10709.847Z",
    transform: "translate(-14852.1 10721.51)",
    fill: "#38a971"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.cf56503ba288be4a418da97a4b883657.svg";
export { ForwardRef as ReactComponent };